<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="editMandature" :validation-schema="MandatureSchema" >
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Libellé <span class="text-danger">*</span>
              </label>
              <Field name="libelle" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le libellé" v-model="formData.libelle" />
              <ErrorMessage name="libelle" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date Début <span class="text-danger">*</span>
              </label>
              <Field name="dateDebut" type="date" class="form-control shadow-none fs-md-15 text-black"
                v-model="formData.dateDebut" />
              <ErrorMessage name="dateDebut" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date Fin <span class="text-danger">*</span>
              </label>
              <Field name="dateFin" type="date" class="form-control shadow-none fs-md-15 text-black"
                v-model="formData.dateFin" />
              <ErrorMessage name="dateFin" class="text-danger" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button type="submit"
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success">
                Modifier
              </button>
              <router-link to="/liste-mandature" class="btn btn-danger transition border-0 lh-1 fw-medium">
                <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, onMounted } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { useRoute, useRouter } from "vue-router";
import ApiService from "../../services/ApiService";
import { error, success } from "../../utils/utils";
export default defineComponent({
  name: "EditMandature",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  setup() {
    const MandatureSchema = Yup.object().shape({
      libelle: Yup.string().required("Le libellé est obligatoire"),
      dateDebut: Yup.date()
        .required("La date de début est obligatoire")
        .typeError("Date invalide"),
      dateFin: Yup.date()
        .required("La date de fin est obligatoire")
        .min(Yup.ref("dateDebut"), "La date de fin doit être postérieure à la date de début")
        .typeError("Date invalide"),
    });

    const router = useRouter();
    const route = useRoute();
    const mandatureId = Number(route.params.id);


    const formData = reactive({
      libelle: "",
      dateDebut: "",
      dateFin: ""
    });

    const getMandature = async (id: number) => {
      try {
        const response = await ApiService.get(`/mandature/${id}`);

        const mandature = response.data.data;
        console.log("Mandature chargée:", mandature);
      
        formData.libelle = mandature.libelle || "";
        formData.dateDebut = mandature.dateDebut?.split("T")[0] || "";
        formData.dateFin = mandature.dateFin?.split("T")[0] || "";

        console.log("FormData après chargement:", formData);
      } catch (err: any) {
        console.error("Erreur:", err);
        error(err.response?.data?.message || "Erreur lors du chargement");
      }
    };

    const editMandature = async (values: any) => {
      try {
        const payload = {
          ...values,
          id: mandatureId
        };
        const { data } = await ApiService.put(`/mandature/${mandatureId}`, payload);
        if (data.code === 200) {
          success(data.message);
          router.push("/liste-mandature");
        }
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors de la modification");
      }
    };
   
    onMounted(async () => {
      if (mandatureId && !isNaN(mandatureId)) {
        await getMandature(mandatureId);
      }
    });
    return {
      MandatureSchema,
      editMandature,
      formData
    };
  },
});
</script>